import { attach } from 'effector';
import { captureErrorFx } from 'model/helpers/analytics.model';
import { render, h } from 'preact';
import { Verify } from 'features/verify';
import { Fallback } from 'features/fallback';
import { RootDomain } from 'model/root.model';
import { MountParams, MountType } from 'model/domain';

export const parentNode$ = RootDomain.store<HTMLElement>(null);

export const mountFx = RootDomain.effect<MountParams, HTMLElement>({
	handler: ({ container, mode, type, error }) => {
		const parentNode = document.createElement('div');
		container.appendChild(parentNode);

		if (error) {
			captureErrorFx(new Error(error.description));
		}

		try {
			if ([MountType.fallback, MountType.invalid_device].includes(type)) {
				render(<Fallback mode={mode} error={error}/>, parentNode);
			} else {
				render(<Verify error={error}/>, parentNode);
			}
		} catch (e) {
			captureErrorFx(e);
		}

		return parentNode;
	},
});

export const unmountFx = attach({
	effect: RootDomain.effect({
		handler: (parentNode: HTMLElement) => {
			render(null, parentNode);
			parentNode.remove();
		},
	}),
	source: parentNode$,
	mapParams(_, source) {
		return source;
	},
});

parentNode$
	.on(mountFx.doneData, (_, parentNode) => parentNode);
